<div id="top" #top></div>

<app-nav (onRouterLinkClick)="onRouterLinkClick($event)" />

<main>
  <router-outlet />
</main>

@if (this.showAction()) {
  <app-action
    [heading]="actionConfig().heading"
    [body]="actionConfig().body"
    [buttonText]="actionConfig().buttonText"
    [link]="actionConfig().link"
  />
}
<app-footer />
